import React, { useState } from 'react';
import {
  LoginContainer,
  LoginForm,
  LoginTitle,
  Input,
  Button,
  ErrorMessage,
} from './styles';
import authService from '../../services/authService';

interface LoginProps {
  onLoginSuccess: () => void;
}

const Login: React.FC<LoginProps> = ({ onLoginSuccess }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await authService.login(username, password);
      onLoginSuccess();
    } catch (err) {
      const error: any = err;
      setError(error.response?.data?.error || 'Erro ao fazer login');
    } finally {
      setLoading(false);
    }
  };

  return (
    <LoginContainer>
      <LoginForm onSubmit={handleSubmit}>
        <LoginTitle>
          <span role="img" aria-label="Login">🔐</span> Login
        </LoginTitle>
        
        <Input
          type="text"
          placeholder="Usuário (user1, user2 ou user3)"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
          disabled={loading}
        />
        
        <Input
          type="password"
          placeholder="Senha (1, 2 ou 3)"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          disabled={loading}
        />
        
        {error && <ErrorMessage>{error}</ErrorMessage>}
        
        <Button type="submit" disabled={loading}>
          {loading ? 'Entrando...' : 'Entrar'}
        </Button>
        
        <div style={{ marginTop: '20px', fontSize: '12px', color: '#666' }}>
          <p>Usuários de teste:</p>
          <p>• user1 / senha: 1</p>
          <p>• user2 / senha: 2</p>
          <p>• user3 / senha: 3</p>
        </div>
      </LoginForm>
    </LoginContainer>
  );
};

export default Login;
